/*
 * These constants moved up to ../styles.ts once a second surface (the Feed
 * Medic report) needed them — they are house style, not account-page specific.
 * Re-exported here so the existing account imports keep working unchanged.
 * New code should import from "@/shadcn/components/styles".
 */

export {
  CARD,
  CARD_DESCRIPTION,
  CARD_HEADER,
  CARD_TITLE,
  MD_BUTTON,
  SM_BUTTON,
} from "../styles"
